import { MessageList } from '../../interfaces/common';
import message from './message.json';

const ListMessage: MessageList = {
  ...message,
};
export { ListMessage };
